import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  rewardsData: [],
  termsAndConditionData: "",
  error: "",
  success: false,
  status: "",
};

const fetchRewards = createAsyncThunk("fetch/rewards", async () => {
  try {
    const result = await axios.get(
      `https://apac.api.capillarytech.com/mobile/v2/api/marvel/reward/detail?cap_brand=${process.env.REACT_APP_BRAND}&language=en`
    );
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const fetchTermsAndCondition = createAsyncThunk(
  "fetch/terms-condition",
  async (
    url = "https://incrm-solutions.s3.amazonaws.com/rewards/29e0b491-55e8-480a-a6e9-b087559.html"
  ) => {
    try {
      const result = await axios.get(url);
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const rewardsSlice = createSlice({
  name: "rewards",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRewards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRewards.fulfilled, (state, action) => {
      // console.log(action.payload, "action payload rewards");
      state.loading = false;
      state.rewardsData = action?.payload?.rewardList;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(fetchRewards.rejected, (state, action) => {
      state.loading = false;
      state.rewardsData = [];
      state.error = action.error.message;
    });

    // Terms and conditions

    builder.addCase(fetchTermsAndCondition.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTermsAndCondition.fulfilled, (state, action) => {
      // console.log(action.payload, "action payload terms and conditions");
      state.loading = false;
      state.termsAndConditionData = action?.payload;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(fetchTermsAndCondition.rejected, (state, action) => {
      state.loading = false;
      state.termsAndConditionData = "";
      state.error = action.error.message;
    });
  },
});

export default rewardsSlice.reducer;
export { fetchRewards, fetchTermsAndCondition };
